/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Flow_Step1_DescInputs */

const en_directory_submit_flow_step1_desc = /** @type {(inputs: Directory_Submit_Flow_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the directory first`)
};

const zh_directory_submit_flow_step1_desc = /** @type {(inputs: Directory_Submit_Flow_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先查重`)
};

/**
* | output |
* | --- |
* | "Check the directory first" |
*
* @param {Directory_Submit_Flow_Step1_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_flow_step1_desc = /** @type {((inputs?: Directory_Submit_Flow_Step1_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Flow_Step1_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_flow_step1_desc(inputs)
	return zh_directory_submit_flow_step1_desc(inputs)
});
export { directory_submit_flow_step1_desc as "directory.submit.flow.step1_desc" }